import styled from "styled-components";
import { Layout, Typography } from "antd";

export const TrainingProgramLayout = styled(Layout)`
  background-color: transparent;
  padding-top: 25px;
  margin-right: 10px;
`;

export const StyledLabel = styled(Typography.Text)`
  font-weight: 400;
  font-size: 14px;
`;

export const StyledBorderedTextLong = styled(Typography.Text)`
  color: #808080;
  display: block;
  direction: rtl;
  font-weight: 400;
  font-size: 14px;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border: 1px solid #f1f1f1;
  height: 48px;
`;

export const StyledBorderedText = styled(Typography.Text)`
  color: #808080;
  display: block;
  text-align: left;
  width: 100%;
  border-radius: 0.25rem;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border: 1px solid #f1f1f1;
  font-weight: 400;
  font-size: 14px;
  padding: 0.75rem 1rem;
`;
